import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../utils/cn";
import { Button } from "../ui/button";

type SubmitButtonProps = React.ComponentProps<typeof Button> & {
  loading?: boolean;
};

const SubmitButton = ({
  loading,
  disabled,
  children,
  className,
  ...props
}: SubmitButtonProps) => (
  <Button
    type="submit"
    disabled={loading || disabled}
    className={cn("h-[52px] w-full rounded-xl text-[15px] font-semibold", className)}
    {...props}
  >
    {loading ? <Loader2 className="size-5 animate-spin" /> : children}
  </Button>
);

export default SubmitButton;
